import "./csp-validation";

// Keep the application graph behind this boundary: static imports can put
// shared schemas in a chunk that executes before the entry module's config.
// Zod must select its non-JIT parser before any of those schemas are created.
void import("./bootstrap");
